import React from "react";
import PropTypes from "prop-types";
import ContributorsDialog from "./ContributorsDilaog";
import { Button } from "discover.medical.react-component-library";
import {
  StyledEndorsement,
  StyledContributors,
  StyledEndorsementLogo,
} from "./_.styled";

import { useContributors } from "./useContributors";
import useToggle from "../../../../hooks/useToggle";

const Contributors = ({ contributors, contributorLogos, className }) => {
  const {
    contributorsPreview,
    allContributors,
    endorsement,
  } = useContributors({ contributors, contributorLogos });

  const {
    isOpen: isDialogOpen,
    handleOpen: onDialogOpen,
    handleCancel: onDialogClose,
  } = useToggle();

  if (!contributors.length) {
    return null;
  }

  return (
    <div className={className}>
      <StyledContributors element="p" display="inline" fontSize="md">
        <strong>Editors:</strong> {contributorsPreview}{" "}
        <Button kind="anchor" onClick={onDialogOpen} fontSize="inherit">
          All Editors & Disclosures
        </Button>
      </StyledContributors>
      {endorsement && (
        <StyledEndorsement marginTop="md" fontSize="xs">
          <StyledEndorsementLogo src={endorsement.src} alt={endorsement.alt} />
          {endorsement.label}
        </StyledEndorsement>
      )}
      <ContributorsDialog
        isOpen={isDialogOpen}
        onClose={onDialogClose}
        contributors={allContributors}
      />
    </div>
  );
};

const contributorPropType = PropTypes.shape({
  affiliationText: PropTypes.string.isRequired,
  conflictsText: PropTypes.string.isRequired,
  degrees: PropTypes.string.isRequired,
  givenName: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  surname: PropTypes.string.isRequired,
});
const acpContributorPropType = PropTypes.shape({
  acpContributor: PropTypes.string.isRequired,
});

Contributors.propTypes = {
  contributors: PropTypes.arrayOf(
    PropTypes.oneOfType([contributorPropType, acpContributorPropType])
  ).isRequired,
  contributorLogos: PropTypes.objectOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired,
    })
  ).isRequired,
  className: PropTypes.string,
};

Contributors.displayName = "Contributors";
export default Contributors;
